import React from 'react';
import './About.css';
import img2 from '../Components/Assets/About2.jpeg';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <span className="badge">About Us</span>
            <h1>We Build Digital Experiences That Matter</h1>
            <p>
              Our team of expert consultants and developers are dedicated to delivering
              solutions that align with your unique goals and challenges. With a commitment
              to excellence and a passion for problem-solving, we empower businesses to
              thrive in the ever-evolving digital landscape.
            </p>
          </div>
        </div>
      </section>

      {/* Pillars */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="badge">Our Approach</span>
            <h2>How We Deliver Value</h2>
          </div>
          <div className="grid-3">
            <div className="pillar-card card">
              <div className="pillar-icon">🎨</div>
              <h3>Design</h3>
              <h5>Create exceptional experiences</h5>
              <p>
                By adopting a product mindset, we design digital products that adhere to
                your strategic roadmap. We use design thinking tools to ensure your products
                enhance the value they provide the people who use them.
              </p>
            </div>
            <div className="pillar-card card">
              <div className="pillar-icon">📊</div>
              <h3>Strategy</h3>
              <h5>Define critical outcomes</h5>
              <p>
                A winning strategy maximizes your business value and focuses on user outcomes.
                We analyze your objectives and every aspect of your organization to create a
                strategic roadmap of your digital transformation journey.
              </p>
            </div>
            <div className="pillar-card card">
              <div className="pillar-icon">⚙️</div>
              <h3>Engineering</h3>
              <h5>Build durable solutions</h5>
              <p>
                We build durable, modern software that delivers on your digital transformation
                objectives. Our technology skills span across the platforms and methodologies
                you use and are scalable, flexible, and secure.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Expertise */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <span className="badge">Expertise</span>
            <h2>Trusted Industry Expertise</h2>
            <p>
              For over 16 years, our founders have partnered with companies in highly 
              regulated and specialized industries to solve their most complex business problems.
            </p>
          </div>

          <div className="expertise-grid">
            <div className="expertise-card">
              <div className="expertise-image">
                <img src={img2} alt="Cloud services" />
              </div>
              <div className="expertise-content">
                <h3>Cloud Migration</h3>
                <h5>Invest In The Cloud For Short and Long-Term Savings</h5>
                <p>
                  Migrating software and systems to the cloud improves scalability, security,
                  and savings. Our cloud experts carefully analyze your business case and
                  existing architecture to plan out a migration roadmap to ensure a smooth transition.
                </p>
                <ul className="expertise-tags">
                  <li>Application Discovery Services</li>
                  <li>OS & Database Migration</li>
                  <li>AWS Cloud Adoption Framework</li>
                  <li>Identity & Access Management</li>
                </ul>
              </div>
            </div>

            <div className="expertise-card expertise-card-reverse">
              <div className="expertise-content">
                <h3>Cloud-Native</h3>
                <h5>Transform and Disrupt With Cloud-Native</h5>
                <p>
                  Our AWS certified cloud application development experts take full leverage
                  of cloud-native services and approaches to design for flexibility and
                  scalability without overengineering. We build applications in event-driven,
                  highly-distributed, and serverless approaches.
                </p>
                <ul className="expertise-tags">
                  <li>Amazon Web Services</li>
                  <li>Serverless Approach</li>
                  <li>Infrastructure as Code</li>
                  <li>DevOps Services</li>
                  <li>Big Data & Analytics</li>
                </ul>
              </div>
              <div className="expertise-image">
                <img src={img2} alt="Cloud native development" />
              </div>
            </div>

            <div className="expertise-card">
              <div className="expertise-image">
                <img src={img2} alt="DevOps practices" />
              </div>
              <div className="expertise-content">
                <h3>DevOps</h3>
                <h5>Combine and Conquer</h5>
                <p>
                  Our DevOps practice automates software development processes to build,
                  test, release, and manage workloads faster and more reliably. Application
                  development and infrastructure operations teams work together towards
                  shared goals for faster time to market.
                </p>
                <ul className="expertise-tags">
                  <li>Automation</li>
                  <li>CI/CD Pipelines</li>
                  <li>Environment Management</li>
                  <li>Configuration Management</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
